import { useCallback, useEffect, useRef, useState } from "react";

const DEFAULT_NOTICE_TIMEOUT = 6_000;

export function useTransientNotice(timeout = DEFAULT_NOTICE_TIMEOUT) {
  const [notice, setNotice] = useState<string | null>(null);
  const timerRef = useRef<number | null>(null);

  const clearTimer = useCallback(() => {
    if (timerRef.current === null) return;
    window.clearTimeout(timerRef.current);
    timerRef.current = null;
  }, []);

  const showNotice = useCallback((message: string) => {
    clearTimer();
    setNotice(message);
    timerRef.current = window.setTimeout(() => {
      timerRef.current = null;
      setNotice(null);
    }, timeout);
  }, [clearTimer, timeout]);

  useEffect(() => () => clearTimer(), [clearTimer]);

  return { notice, showNotice };
}
